<template>
  <div>
    <b-card class="border-none">
      <div class="flex justify-between items-center">
        <div>
          <h2 class="text-2xl font-semibold">Subscription Plans</h2>
        </div>
        <base-button
          outline
          class="px-6 py-1 mx-1"
          type="primary"
          v-b-modal.modal-10
        >
          <span class="btn-inner--text flex justify-between items-center"
            ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon>Add
            Plan</span
          >
        </base-button>
        <b-modal id="modal-10" title="Add Plan" hide-footer>
          <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
            <b-form role="form" @submit.prevent="handleSubmit(handleCreate)">
              <div>
                <!-- <b-form-group label="Plan Icon" class="formmb">
                  <div class="mt-4">
                    <FileUploader
                      v-show="!image"
                      :image="image"
                      :onSuccess="handleSuccess"
                      class="rounded-full widtht20percent m-auto display-none custmodal"
                    />
                    <img
                      v-if="image"
                      :src="image"
                      ref="cover"
                      class="rounded-full widtht20percent m-auto display-none custmodal"
                    />
                    <div
                      class="text-center text-red"
                      v-if="image"
                      @click="handleRemove"
                    >
                      Remove image
                    </div>
                  </div>
                </b-form-group> -->
                <b-form-group label="" class="formmb">
                  <p class="font-semibold text-sm">
                    Plan Name<span class="clr-red">*</span>
                  </p>
                  <base-input
                    v-model="Planname"
                    placeholder="Enter input"
                    name="Plan"
                    :rules="{ required: true }"
                  ></base-input>
                </b-form-group>
                <b-form-group label="" class="formmb">
                  <p class="font-semibold text-sm">Plan Description</p>
                  <base-input
                    v-model="PlanDes"
                    placeholder="Enter input"
                    name="Plan Description"
                  ></base-input>
                </b-form-group>
                <b-form-group label="" class="formmb">
                  <p class="font-semibold text-sm">Plans Includes</p>

                  <multiselect
                    name="membership"
                    v-model="selectedMembership"
                    :options="memFilter"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Select Memberships"
                    track-by="name"
                    label="name"
                    @select="planSelect"
                    @remove="planRemove"
                    :preselect-first="false"
                  >
                  </multiselect>
                </b-form-group>
                <b-form-group label="" class="formmb">
                  <p class="font-semibold text-sm">
                    Features Included<span class="clr-red">*</span>
                  </p>

                  <multiselect
                    name="incFeat"
                    v-model="incFeat"
                    :options="featureFilter"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Select Features"
                    track-by="title"
                    label="title"
                    :preselect-first="false"
                  >
                  </multiselect>
                </b-form-group>

                <b-form-group label="" class="formmb">
                  <p class="font-semibold text-sm">Features Excluded</p>
                  <multiselect
                    name="excFeat"
                    v-model="excFeat"
                    :options="featureFilter"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Select Features"
                    track-by="title"
                    label="title"
                    :preselect-first="false"
                  >
                  </multiselect>
                </b-form-group>

                <!-- <b-form-group label="" class="formmb">
                  <p class="font-semibold text-sm">
                    Validity (In days)<span class="clr-red">*</span>
                  </p>

                  <base-input
                    v-model="Planvali"
                    placeholder="Enter input"
                    name="Validity"
                    :rules="{ numeric: true, required: true }"
                  ></base-input>
                </b-form-group> -->
                <div class="mb-2">
                  <b-form-group label="" class="formmb">
                    <p>
                      <b-form-checkbox id="checkbox-2" v-model="contactUs">
                        <strong>
                          <p class="col-blk">
                            To be purchased after contacting?
                          </p></strong
                        >
                      </b-form-checkbox>
                    </p>
                  </b-form-group>
                </div>
                <b-form-group label="" class="formmb">
                  <p class="font-semibold text-sm">Is Plan free?</p>
                  <p class="font-normal">
                    No
                    <el-switch class="bgtoggle" v-model="isFree"> </el-switch>
                    Yes
                  </p>
                </b-form-group>
                <template v-if="!isFree">
                  <b-form-group label="" class="formmb">
                    <p class="font-semibold text-sm">Discount (%)</p>
                    <base-input
                      v-model="discount"
                      placeholder="Enter input"
                      name="Discount"
                      :rules="{
                        numeric: true,
                        regex: '^(0?[0-9]|[0-9][0-9])$',
                      }"
                    ></base-input>
                  </b-form-group>
                  <!-- <b-form-group label="" class="formmb">
                  <p class="font-semibold text-sm">Price</p>
                  <base-input
                    v-model="Planpric"
                    placeholder="Enter input"
                    name="Price"
                    :rules="{
                      numeric: true,
                    }"
                  ></base-input>
                </b-form-group> -->
                  <!-- <b-form-group label="" class="formmb">
                    <p class="font-semibold text-sm">Annual Price</p>
                    <base-input
                      v-model="Planpric_12"
                      placeholder="Enter input"
                      name="Price"
                      :rules="{
                        numeric: true,
                      }"
                    ></base-input>
                  </b-form-group>
                  <b-form-group label="" class="formmb">
                    <p class="font-semibold text-sm">6 Month Price</p>
                    <base-input
                      v-model="Planpric_6"
                      placeholder="Enter input"
                      name="Price"
                      :rules="{
                        numeric: true,
                      }"
                    ></base-input>
                  </b-form-group>
                  <b-form-group label="" class="formmb">
                    <p class="font-semibold text-sm">3 Month Price</p>
                    <base-input
                      v-model="Planpric_3"
                      placeholder="Enter input"
                      name="Price"
                      :rules="{
                        numeric: true,
                      }"
                    ></base-input>
                  </b-form-group> -->
                  <div
                    v-for="(item, index) in monthPrice"
                    :key="index"
                    class="flex justify-normal"
                  >
                    <b-form-group label="" class="formmb w-32 px-1">
                      <p class="font-semibold text-sm">Month</p>
                      <base-input
                        class="py-2"
                        v-model="item.month"
                        placeholder="Enter number of months"
                        name="Months"
                        :rules="{
                          numeric: true,
                        }"
                        @change="item.month = parseInt(item.month)"
                      ></base-input>
                    </b-form-group>
                    <b-form-group label="" class="formmb w-32 px-1">
                      <p class="font-semibold text-sm">Price</p>
                      <base-input
                        class="py-2"
                        v-model="item.price"
                        placeholder="Enter price"
                        name="Price"
                        :rules="{
                          numeric: true,
                        }"
                        @change="item.price = parseInt(item.price)"
                        @keyup="
                          item.discountPrice =
                            item.price -
                            ((item.price * discount) / 100).toFixed(2)
                        "
                      ></base-input>
                    </b-form-group>
                    <b-form-group label="" class="formmb w-32 px-1">
                      <p class="font-semibold text-sm">Discount Price</p>
                      <base-input
                        disabled
                        class="py-2"
                        v-model="item.discountPrice"
                        placeholder="Enter price"
                        name="Price"
                        :rules="{
                          numeric: true,
                        }"
                      ></base-input>
                    </b-form-group>
                    <div class="py-5">
                      <base-button
                        outline
                        type="primary"
                        class="px-2"
                        @click.stop="removeField(index)"
                        >Remove</base-button
                      >
                    </div>
                  </div>
                  <div class="py-3">
                    <base-button outline type="primary" @click.stop="addField()"
                      >Add Pricing</base-button
                    >
                  </div>
                </template>
                <div class="flex justify-center">
                  <b-button type="submit" variant="primary">Save</b-button>
                </div>
              </div>
            </b-form>
          </validation-observer>
        </b-modal>
      </div>
      <b-input-group class="mt-12">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          v-model="search"
          placeholder="Enter Search...."
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>

      <div>
        <div class="grid lg:grid-cols-3 md:grid-cols-3 gap-4 my-4 mob-hidden">
          <template v-if="admin_membership[0].result.length !== 0">
            <div
              class="white-bg lg:px-8 lg:pt-8 md:px-8 md:pt-8 pt-8 pb-20 px-8 shadow-lg rounded-md relative"
              v-for="item in admin_membership[0].result"
              :key="item._id"
            >
              <h1 class="font-semibold fsize22">{{ item.name }}</h1>
              <h2 class="font-semibold py-1 fsize18" v-if="item.isFree">
                Price - Free
              </h2>

              <template v-if="!item.isFree" v-for="ele in item.monthPrice">
                <h2 class="font-semibold py-1 fsize18">
                  {{ ele.month }} month price -
                  {{ ele.price > 0 ? "₹ " + ele.price + "/-" : "Free" }}
                </h2>
                <!-- <h2 class="font-semibold py-1 fsize18">
                  Half-Yearly Price -
                  {{ item.price_6 > 0 ? "₹ " + item.price_6 + "/-" : "Free" }}
                </h2>
                <h2 class="font-semibold py-1 fsize18">
                  Quarterly Price -
                  {{ item.price_3 > 0 ? "₹ " + item.price_3 + "/-" : "Free" }}
                </h2> -->
              </template>
              <!-- <h2 class="font-semibold py-1 fsize18">
                Discount - {{ item.price > 0 ? item.discount : "0" }}%
              </h2>
              <h2 class="font-semibold py-1 fsize18">
                Final Price -
                {{
                  item.discountPrice > 0
                    ? "₹ " + item.discountPrice + "/-"
                    : "Free"
                }}
              </h2> -->
              <!-- <h2 class="font-semibold py-1 fsize18">
                Validity - {{ item.validity }} days
              </h2> -->
              <p class="caption">{{ item.description }}</p>
              <div class="my-4">
                <div
                  class="flex items-center gap-4 mb-2 mb-2"
                  v-for="feature in item.features"
                  :key="feature._id"
                >
                  <feather-icon
                    icon="CheckIcon"
                    class="right-icon checkicon"
                  ></feather-icon>

                  <p class="fsize14 text-black">
                    {{ feature.title }}
                  </p>
                </div>
              </div>
              <div class="my-6">
                <div
                  class="flex items-center gap-4 mb-2 mb-2"
                  v-for="feature in item.featuresExcluded"
                  :key="feature._id"
                >
                  <feather-icon
                    icon="XIcon"
                    class="right-icon crossicon"
                  ></feather-icon>

                  <p class="fsize14 text-black">
                    {{ feature.title }}
                  </p>
                </div>
              </div>

              <div class="pl-11 absolute bottom-10">
                <div class="flex items-center justify-center gap-7">
                  <div class="cursor-pointer">
                    <el-button
                      type="button"
                      class="font-bold text-primary bg-white border-primary border-4 py-1 px-5"
                      v-b-modal.modal-11
                      @click="fillEditFields(item._id)"
                    >
                      Edit
                    </el-button>
                  </div>
                  <div class="cursor-pointer">
                    <el-button
                      type="button"
                      class="font-bold text-primary bg-white border-primary border-4 py-1 px-3"
                      @click="handleDelete(item._id)"
                    >
                      Delete
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div
              class="white-bg lg:px-8 lg:py-8 md:px-8 md:py-8 py-8 px-8 shadow-lg rounded-md"
            >
              <h1 class="font-bold fsize24-18">{{ "No Matching Data" }}</h1>
            </div>
          </template>
          <b-modal id="modal-11" title="Edit Plan" hide-footer>
            <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
              <b-form role="form" @submit.prevent="handleSubmit(handleEdit)">
                <div>
                  <!-- <b-form-group label="Plan Icon" class="formmb">
                    <div class="mt-4">
                      <FileUploader
                        v-show="!editImage"
                        :image="editImage"
                        :onSuccess="handleSuccess"
                        class="rounded-full widtht20percent m-auto display-none custmodal"
                      />
                      <img
                        v-if="editImage"
                        :src="$imageURL + '/' + editImage"
                        ref="cover"
                        class="rounded-full widtht20percent m-auto display-none custmodal"
                      />
                      <div
                        class="text-center text-red"
                        v-if="editImage"
                        @click="handleRemove"
                      >
                        Remove image
                      </div>
                    </div>
                  </b-form-group> -->
                  <b-form-group label="" class="formmb">
                    <p class="font-semibold text-sm">
                      Plan Name<span class="clr-red">*</span>
                    </p>
                    <base-input
                      v-model="PlannameEdit"
                      placeholder="Enter input"
                      name="Plan"
                      :rules="{ required: true }"
                    ></base-input>
                  </b-form-group>
                  <b-form-group label="" class="formmb">
                    <p class="font-semibold text-sm">Plan Description</p>
                    <base-input
                      v-model="PlanDesEdit"
                      placeholder="Enter input"
                      name="Plan Description"
                    ></base-input>
                  </b-form-group>
                  <b-form-group label="" class="formmb">
                    <p class="font-semibold text-sm">Plans Includes</p>
                    <multiselect
                      name="membership"
                      v-model="planMembership"
                      :options="membershipFilter"
                      :multiple="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Memberships"
                      track-by="name"
                      label="name"
                      @select="planEditSelect"
                      @remove="planEditRemove"
                      :preselect-first="false"
                    >
                    </multiselect>
                  </b-form-group>
                  <b-form-group label="" class="formmb">
                    <p class="font-semibold text-sm">
                      Features Included<span class="clr-red">*</span>
                    </p>
                    <multiselect
                      name="incFeat"
                      v-model="valInclude"
                      :options="getAllFeatures.featureRecord"
                      :multiple="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Features"
                      track-by="_id"
                      label="title"
                      :preselect-first="false"
                    >
                    </multiselect>
                  </b-form-group>
                  <b-form-group label="" class="formmb">
                    <p class="font-semibold text-sm">Features excluded</p>
                    <multiselect
                      name="excFeat"
                      v-model="valExclude"
                      :options="getAllFeatures.featureRecord"
                      :multiple="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Features"
                      track-by="_id"
                      label="title"
                      :preselect-first="false"
                    >
                    </multiselect>
                  </b-form-group>
                  <!-- <b-form-group label="" class="formmb">
                    <p class="font-semibold text-sm">
                      Validity (In days)<span class="clr-red">*</span>
                    </p>
                    <base-input
                      v-model="PlanvaliEdit"
                      placeholder="Enter input"
                      name="Validity"
                      :rules="{ required: true, numeric: true }"
                    ></base-input>
                  </b-form-group> -->
                  <div class="mb-2">
                    <b-form-group label="" class="formmb">
                      <p>
                        <b-form-checkbox
                          id="checkbox-2"
                          v-model="contactUsEdit"
                        >
                          <strong>
                            <p class="col-blk">
                              To be purchased after contacting?
                            </p>
                          </strong>
                        </b-form-checkbox>
                      </p>
                    </b-form-group>
                  </div>
                  <b-form-group label="" class="formmb">
                    <p class="font-semibold text-sm">Is Plan free?</p>
                    <p class="font-normal">
                      No
                      <el-switch class="bgtoggle" v-model="isFreeEdit">
                      </el-switch>
                      Yes
                    </p>
                  </b-form-group>
                  <template v-if="!isFreeEdit">
                    <b-form-group label="" class="formmb">
                      <p class="font-semibold text-sm">Discount (%)</p>
                      <base-input
                        v-model="planDiscount"
                        placeholder="Enter input"
                        name="Discount"
                        :rules="{
                          numeric: true,
                          regex: '^(0?[0-9]|[0-9][0-9])$',
                        }"
                      ></base-input>
                    </b-form-group>
                    <!-- <b-form-group label="" class="formmb">
                    <p class="font-semibold text-sm">Price</p>
                    <base-input
                      v-model="PlanpricEdit"
                      placeholder="Enter input"
                      name="Price"
                      :rules="{ numeric: true }"
                    ></base-input>
                  </b-form-group> -->
                    <!-- <b-form-group label="" class="formmb">
                      <p class="font-semibold text-sm">Annual Price</p>
                      <base-input
                        v-model="PlanpricEdit_12"
                        placeholder="Enter input"
                        name="Price"
                        :rules="{
                          numeric: true,
                        }"
                      ></base-input>
                    </b-form-group>
                    <b-form-group label="" class="formmb">
                      <p class="font-semibold text-sm">6 Month Price</p>
                      <base-input
                        v-model="PlanpricEdit_6"
                        placeholder="Enter input"
                        name="Price"
                        :rules="{
                          numeric: true,
                        }"
                      ></base-input>
                    </b-form-group>
                    <b-form-group label="" class="formmb">
                      <p class="font-semibold text-sm">3 Month Price</p>
                      <base-input
                        v-model="PlanpricEdit_3"
                        placeholder="Enter input"
                        name="Price"
                        :rules="{
                          numeric: true,
                        }"
                      ></base-input>
                    </b-form-group> -->
                    <div
                      v-for="(item, index) in monthPrice"
                      :key="index"
                      class="flex justify-normal"
                    >
                      <b-form-group label="" class="formmb w-32 px-1">
                        <p class="font-semibold text-sm">Month</p>
                        <base-input
                          type="number"
                          class="py-2"
                          v-model="item.month"
                          placeholder="Enter number of months"
                          name="Months"
                          :rules="{
                            numeric: true,
                          }"
                          @change="item.month = parseInt(item.month)"
                        ></base-input>
                      </b-form-group>
                      <b-form-group label="" class="formmb w-32 px-1">
                        <p class="font-semibold text-sm">Price</p>
                        <base-input
                          type="number"
                          class="py-2"
                          v-model="item.price"
                          placeholder="Enter price"
                          name="Price"
                          :rules="{
                            numeric: true,
                          }"
                          @change="item.price = parseInt(item.price)"
                          @keyup="
                            item.discountPrice =
                              item.price -
                              ((item.price * planDiscount) / 100).toFixed(2)
                          "
                        ></base-input>
                      </b-form-group>
                      <b-form-group label="" class="formmb w-32 px-1">
                        <p class="font-semibold text-sm">Discount Price</p>
                        <base-input
                          disabled
                          class="py-2"
                          v-model="item.discountPrice"
                          placeholder="Enter price"
                          name="Price"
                          :rules="{
                            numeric: true,
                          }"
                        ></base-input>
                      </b-form-group>
                      <div class="py-5">
                        <base-button
                          outline
                          type="primary"
                          class="px-2"
                          @click.stop="removeField(index)"
                          >Remove</base-button
                        >
                      </div>
                    </div>
                    <div class="py-3">
                      <base-button
                        outline
                        type="primary"
                        @click.stop="addField()"
                        >Add Pricing</base-button
                      >
                    </div>
                  </template>

                  <div class="flex justify-center">
                    <b-button type="submit" variant="primary">Save</b-button>
                  </div>
                </div>
              </b-form>
            </validation-observer>
          </b-modal>
        </div>

        <b-card-footer class="py-4 d-flex justify-content-end">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            aria-controls="my-table"
          ></b-pagination>
        </b-card-footer>
      </div>
    </b-card>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import FileUploader from "../../../../views/social/admin/pages/admin-banner/components/FileUploader.vue";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";
import PlanMultiselect from "./PlanMultiselect.vue";
export default {
  components: {
    FileUploader,
    // swiper,
    // swiperSlide,
  },
  data() {
    return {
      monthPrice: [],
      image: null,
      editImage: null,
      coverImage: null,
      value: [],
      valInclude: null,
      valExclude: null,
      discount: 0,
      planDiscount: 0,
      currMembership: {},
      membershipId: "",
      search: "",
      currTransactionId: "",
      selectedUsers: null,
      selectedPlan: null,
      selectedUsersId: [],
      Planname: "",
      PlanDes: "",
      Planvali: "",
      PlanpricEdit: 0,
      Planpric_12: 0,
      Planpric_6: 0,
      Planpric_3: 0,
      PlannameEdit: "",
      PlanDesEdit: "",
      PlanFeEdit: "",
      PlanvaliEdit: "",
      PlanpricEdit: "",
      PlanpricEdit_12: 0,
      PlanpricEdit_6: 0,
      PlanpricEdit_3: 0,
      planMembership: null,
      filter10: ["hello", "eee", "hdshfas", "gei"],
      perPage: 6,
      currentPage: 1,
      totalRows: 5,
      selectedMembership: null,
      incFeat: null,
      excFeat: null,
      membershipFilter: [],
      excluded: [],
      featureFilter: [],
      memFilter: [],
      isFree: true,
      isFreeEdit: false,
      contactUsEdit: false,
      contactUs: false,
    };
  },
  watch: {
    pageData(val) {
      if (selectedUserData.length > 0) {
        this.selectedUsers = this.filter3.filter((tag) =>
          selectedUserData.includes(tag._id)
        );
      }
    },
    selectedUsers(val) {
      this.selectedUsersId = val.map((tag) => tag._id);
    },

    contactUs(val) {
      if (val) {
        this.isFree = false;
      }
    },

    contactUsEdit(val) {
      if (val) {
        this.isFreeEdit = false;
      }
    },

    async currentPage() {
      await this.getAdminMembership();
    },
    async search() {
      await this.getAdminMembership();
    },
  },
  methods: {
    removeField(index) {
      this.monthPrice.splice(index, 1);
    },
    addField() {
      this.monthPrice.push({ month: 0, price: 0, discountPrice: 0 });
    },
    planEditSelect(selectedOption) {
      this.valInclude = selectedOption.features;
      this.valExclude = selectedOption.featuresExcluded;
    },
    planEditRemove(removedOption) {
      this.valInclude = this.valInclude.filter(
        (objA) => !removedOption.features.some((objB) => objB._id === objA._id)
      );
      this.valExclude = this.valExclude.filter(
        (objA) =>
          !removedOption.featuresExcluded.some((objB) => objB._id === objA._id)
      );
    },
    planSelect(selectedOption) {
      this.incFeat = selectedOption.features;
      this.excFeat = selectedOption.featuresExcluded;
    },
    planRemove(removedOption) {
      this.incFeat = this.incFeat.filter(
        (objA) => !removedOption.features.some((objB) => objB._id === objA._id)
      );
      this.excFeat = this.excFeat.filter(
        (objA) =>
          !removedOption.featuresExcluded.some((objB) => objB._id === objA._id)
      );
    },
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          // text: "Please ensure that the file size does not exceed 5MB",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      // console.log(image);
      this.coverImage = image;
      // console.log(this.coverImage);
      this.readerData(image);
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));
        this.$emit("load", (this.editImage = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    handleRemove() {
      this.editImage = null;
      this.image = null;
      this.coverImage = null;
    },

    closeModal(modal) {
      this.$nextTick(() => {
        this.$bvModal.hide(modal);
      });
    },

    async handleDelete(id) {
      const result = await this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (result.isConfirmed) {
        let loader;
        let payload = {
          membershipId: id,
        };
        loader = this.$loading();
        try {
          const data = await this.$store.dispatch(
            "subscribe/DeleteMembership",
            payload
          );
          loader.close();
          await this.init();
          await this.getAdminMembership();
          if (data && data.code === 200) {
            this.init();
            await this.$swal({
              text: "Subscription Plan deleted successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#830c81",
            });
          }
        } catch (err) {
          console.log(err);
          loader.close();
        }
      }
    },
    discountCalc(price, discount) {
      return (price - (price * discount) / 100).toFixed(2);
    },
    async handleCreate() {
      if (this.selectedMembership == null) this.selectedMembership = [];
      if (this.excFeat == null) this.excFeat = [];
      if (this.incFeat == null) this.incFeat = [];
      if (this.Planpric == null) this.Planpric = 0;
      if (this.Planpric_12 == null) this.Planpric_12 = 0;
      if (this.Planpric_6 == null) this.Planpric_6 = 0;
      if (this.Planpric_3 == null) this.Planpric_3 = 0;
      if (this.incFeat.length < 1) {
        this.$swal.fire({
          text: "Please fill all mandatory fields!",
          icon: "warning",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      let payload = new FormData();
      let include = [];
      this.incFeat.forEach((element) => {
        include.push(element._id);
      });

      let exclude = [];

      this.excFeat.forEach((element) => {
        exclude.push(element._id);
      });

      let plans = [];

      this.selectedMembership.forEach((element) => {
        plans.push(element._id);
      });

      payload.append("name", this.Planname.trim());
      payload.append("description", this.PlanDes);
      payload.append("isFree", this.isFree);
      payload.append("contactUs", this.contactUs);
      payload.append("features", JSON.stringify(include));
      payload.append("featuresExcluded", JSON.stringify(exclude));
      payload.append("monthPrice", JSON.stringify(this.monthPrice));
      // payload.append("validity", this.Planvali);
      payload.append("price", this.Planpric);
      if (this.selectedMembership != null)
        payload.append("plansIncluded", JSON.stringify(plans));
      payload.append("image", this.coverImage);
      payload.append("discount", this.discount);
      let discountPrice = this.discountCalc(this.Planpric, this.discount);
      payload.append("discountPrice", discountPrice);
      try {
        if (this.incFeat == null) {
          this.$swal.fire({
            text: "Please include some features",
            icon: "warning",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }

        if (this.incFeat.some((el) => this.excFeat.includes(el))) {
          this.$swal.fire({
            text: "You can't include and exclude features at same time",
            icon: "warning",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        } else {
          const created = await this.$store.dispatch(
            "subscribe/CreateMembership",
            payload
          );
          if (created.code == 200) {
            this.closeModal("modal-10");
            this.init();
            this.getAdminMembership();
            this.$swal.fire({
              text: "Subscription Plan added successfully",
              icon: "success",
              confirmButtonText: "Okay",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
            this.resetForm();
          }
          // console.log("created");
        }
      } catch (error) {
        console.log("error");
        console.log(error);
      }
    },

    async handleEdit() {
      let filteredMembershipAPIData = await this.$store.dispatch(
        "subscribe/GetAllMembership"
      );
      if (this.PlanpricEdit == null) this.PlanpricEdit = 0;

      if (this.valInclude.length < 1) {
        return this.$swal.fire({
          text: "Please fill all mandatory fields!",
          icon: "warning",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
      }
      // let FormData = require("form-data");
      let data = new FormData();
      // let payload = {
      //   name: this.PlannameEdit,
      //   description: this.PlanDesEdit,
      //   features: this.valInclude,
      //   featuresExcluded: this.valExclude,
      //   validity: this.PlanvaliEdit,
      //   price: this.PlanpricEdit,
      //   membershipId: this.membershipId,
      //   plansIncluded: this.planMembership,
      //   discount: this.planDiscount,
      // };
      let include = [];
      // if (this.valInclude != null) {
      this.valInclude.forEach((element) => {
        include.push(element._id);
      });
      // }

      let exclude = [];
      // if (this.valExclude != null) {
      this.valExclude.forEach((element) => {
        exclude.push(element._id);
      });
      // }

      let plans = [];
      // if (this.planMembership != null) {
      this.planMembership.forEach((element) => {
        plans.push(element._id);
      });
      // }

      data.append("name", this.PlannameEdit);
      data.append("description", this.PlanDesEdit);
      data.append("features", JSON.stringify(include));
      data.append("featuresExcluded", JSON.stringify(exclude));
      data.append("validity", this.PlanvaliEdit);
      data.append("price", this.PlanpricEdit);
      data.append("monthPrice", JSON.stringify(this.monthPrice));
      data.append("plansIncluded", JSON.stringify(plans));
      data.append("isFree", this.isFreeEdit);
      data.append("contactUs", this.contactUsEdit);

      // data.append("image", this.coverImage);
      data.append("discount", this.planDiscount);
      let discountPrice = this.discountCalc(
        this.PlanpricEdit,
        this.planDiscount
      );

      data.append("discountPrice", discountPrice);
      data.append("membershipId", this.membershipId);
      // console.log(data);
      try {
        // if (this.valExclude != null && this.valInclude != null) {
        if (this.valInclude.some((el) => this.valExclude.includes(el))) {
          this.$swal.fire({
            text: "You can't include and exclude features at same time",
            icon: "warning",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          // }
        } else {
          const edited = await this.$store.dispatch(
            "subscribe/UpdateMembership",
            data
          );
          if (edited.code == 200) {
            this.closeModal("modal-11");
            this.getAdminMembership();
            this.$swal.fire({
              text: "Subscription Plan updated successfully",
              icon: "success",
              confirmButtonText: "Okay",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
            this.monthPrice = [];

            // this.resetForm();
          }
          // console.log(edited);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fillEditFields(id) {
      const { data } = await this.$store.dispatch("subscribe/GetMembership", {
        _id: id,
      });
      // console.log(data);
      // this.valInclude;
      this.membershipFilter = this.get_all_membership.filter(
        (item) => item._id != id
      );
      // console.log(this.membershipFilter);
      this.PlannameEdit = data.name;
      this.PlanDesEdit = data.description;
      // this.cancelButtonColor = data.features;
      this.valExclude = data.featuresExcluded;
      this.valInclude = data.features;
      this.PlanvaliEdit = data.validity;
      this.PlanpricEdit = data.price;
      this.isFreeEdit = data.isFree;
      this.membershipId = id;
      this.planMembership = data.plansIncluded;
      this.planDiscount = data.discount;
      this.editImage = data.image;
      this.monthPrice = data.monthPrice;
      this.contactUsEdit = data.contactUs;
    },
    resetForm() {
      this.Planname = "";
      // this.city = "";
      this.PlanDes = "";
      this.value = [];
      this.Planvali = "";
      this.Planpric = "";
      this.excluded = [];
      this.incFeat = [];
      this.excFeat = [];
      this.discount = 0;
      this.monthPrice = [];
    },
    async init() {
      this.monthPrice = [
        { month: 3, price: 0, discountPrice: 0 },
        { month: 6, price: 0, discountPrice: 0 },
        { month: 12, price: 0, discountPrice: 0 },
      ];
      await this.$store.dispatch("subscribe/GetAllMembership");
      var offset = this.currentPage - 1;
      let getUserPayload = {
        userId: this.user._id,
      };
      const getUser = await this.$store.dispatch(
        "auth/getUserByUserId",
        getUserPayload
      );
      this.featureFilter = [];
      this.memFilter = [];
      // console.log("INIT", this.getUserByUserId, this.get_all_membership);
      // console.log({ membership: this.get_all_membership });
      this.getAllFeatures.featureRecord.forEach((element) => {
        this.featureFilter.push(element);
      });
      this.get_all_membership.forEach((ele) => {
        this.memFilter.push(ele);
      });
    },
    async getAdminMembership() {
      var offset = this.currentPage - 1;
      var limit = this.perPage;
      let payload = {
        limit: limit,
        offset: offset,
        search: this.search,
      };
      await this.$store.dispatch("subscribe/GetMembershipForAdmin", payload);
      this.totalRows = this.admin_membership[0].totalCount;
      // console.log({ membership: this.admin_membership });
    },
  },
  computed: {
    ...mapState("subscribe", {
      get_all_membership: "get_all_membership",
      admin_membership: "admin_membership",
      getAllFeatures: "getAllFeatures",
    }),
    ...mapState("auth", { user: "user" }),
    ...mapState("auth", { getUserByUserId: "getUserByUserId" }),
  },
  // watch: {
  //   getUserByUserId() {},
  //   async currentPage() {
  //     await this.init();
  //   },
  // },
  async mounted() {
    await this.$store.dispatch("subscribe/GetAllFeatures");
    await this.init();
    await this.getAdminMembership();
    // this.addField();
  },
};
</script>
<style>
.modal-header {
  display: flex !important;
  align-items: center !important;
  background-color: #4f0a4b !important;
  border-color: #4f0a4b !important;
  padding: 1rem !important;
}
.modal-title {
  font-size: 20px !important;
  color: #fff !important;
}
.form-group.formmb {
  margin-bottom: 1rem !important;
}
.badge-secondary {
  color: black;
  background-color: rgb(40 35 35 / 12%);
  margin-right: 5px;
}
.checkicon .feather-check {
  width: 16px !important;
  height: 16px !important;
}
.crossicon .feather-x {
  width: 16px !important;
  height: 16px !important;
}
</style>
